import { DeviceEnabledType, UserAttributeDefs, ValidModelType } from '@iotv/datamodel-core'
import { PathDirection, ValidBusinessObject } from '@iotv/iotv-v3-types'

type SensorMeasurements = 'moistureWithSalinity' | 'salinity' | 'temperatureC' | 'moistureWithoutSalinity' | 'temperatureF'
type SoilReadings = Partial<{ [k in SensorMeasurements]: number[] }>

const typeName = 'SoilMoisture'

export type SoilMoistureProps = {
  purpose?: string
  sensorModel?: string
  depth: number
  sensorDistance: number
  soilTemperature?: number
  // moisture?: number
  image?: string
  // readings?: Readings
  readingCount: number
} & SoilReadings

export class SoilMoisture extends DeviceEnabledType implements SoilMoistureProps, ValidBusinessObject {
  constructor(ob: any, readers?: SoilReadings) {
    super(ob.type || typeName, ob)
    this.purpose = ob.purpose
    this.sensorModel = ob.sensorModel
    this.depth = ob.depth
    this.sensorDistance = ob.sensorDistance || 10
    this.soilTemperature = ob.soilTemperature
    // this.moisture = ob.moisture
    this.image = ob.image
    this.readings = ob.readings
    this.readingCount = ob.readingCount || 1
    // this.eui = device?.eui;

    if (readers) {
      let longestOption = 1
      Object.keys(readers).forEach((readerKey) => {
        let keyValues = readers[readerKey as SensorMeasurements]
        this[readerKey] = keyValues

        if (keyValues && keyValues.length > longestOption) {
          longestOption = keyValues.length
        }
      })
      this.readingCount = longestOption
    }
  }

  purpose?: string
  sensorModel?: string
  depth: number
  sensorDistance: number
  soilTemperature?: number
  image?: string
  // readings?: Readings
  // moisture: number
  readingCount: number

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: {
        type: 'String',
        editable: true,
        label: 'Name',
        name: 'name',
        description: 'Name of soil moisture measurement point',
      },
      purpose: {
        type: 'String',
        editable: true,
        label: 'Purpose',
        name: 'purpose',
        description: 'Measurement purpose',
      },
      sensorModel: {
        type: 'String',
        editable: true,
        label: 'Sensor Model',
        name: 'sensorModel',
        description: 'Model of Soil Moisture Sensor and Sensor details',
      },
      depth: {
        type: 'Number',
        editable: true,
        required: true,
        label: 'Sensor Depth (mm)',
        name: 'depth',
        description: 'Depth of the sensor (mm)',
      },
      sensorDistance: {
        type: 'Number',
        editable: true,
        required: true,
        label: 'Distance Between Sensors (mm)',
        name: 'depth',
        description: 'Distance between sensors (mm)',
      },
      moisture: {
        type: 'Number',
        editable: true,
        label: 'Moisture (%)',
        name: 'Moisture',
        description: 'Moisture level (%)',
      },
      soilTemperature: {
        type: 'Number',
        editable: true,
        label: 'Soil Temperature (°C)',
        name: 'soilTemperature',
        description: 'Soil temperature (°C)',
      },
      Location: {
        type: 'RelatedType',
        editable: false,
        label: 'Location',
        name: 'Location',
        description: 'Location of Soil Moisture (lat/ long)',
        objectTypeId: 'Soil_Moisture|P' as ValidModelType,
        direction: PathDirection.child,
        edgeTypeId: 'Soil_Moisture_has_Location_Soil_Moisture|P',
      },
      image: {
        type: 'String',
        editable: true,
        label: 'Image',
        name: 'image',
        description: 'Photograph of Soil Moisture in situ',
      },
    }
  }
}
